import styled from "styled-components";

export const DesktopNav = styled.div`
  ul {
    display: flex;
    align-items: center;
    list-style: none;
    gap: 1.5rem;
    text-transform: uppercase;

    & a {
      font-weight: 500;
      color: #fff;
      text-decoration: none;
      padding: 13px 20px;
      border-radius: 2px;

      &:not(.contact).active {
        color: ${({ theme }) => theme.colors.primaryLight};

        &:hover {
          color: #fff;
        }
      }

      &:not(.contact):hover {
        background-color: ${({ theme }) => theme.colors.primaryLight};
      }

      &.contact {
        background-color: ${({ theme }) => theme.colors.primaryLight};
        line-height: 17px;

        &:hover {
          background-color: ${({ theme }) => theme.colors.primaryDark};
          transition: all 0.4s ease-in-out;
        }
      }
    }    
  }
`;
